import { Bell, Loader2 } from 'lucide-react'
import { NotificationItem } from './NotificationItem'
import type { UserNotification } from '../types'

interface NotificationListProps {
  notifications: UserNotification[]
  isLoading: boolean
  onMarkAsRead: (id: string) => void
  onDelete: (id: string) => void
  onNotificationClick?: (notification: UserNotification) => void
}

export function NotificationList({
  notifications,
  isLoading,
  onMarkAsRead,
  onDelete,
  onNotificationClick,
}: NotificationListProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
      </div>
    )
  }

  if (notifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-gray-400">
        <Bell className="h-12 w-12 mb-2" />
        <p className="text-sm">No notifications</p>
      </div>
    )
  }

  return (
    <div className="divide-y divide-gray-100 dark:divide-gray-800">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onMarkAsRead={onMarkAsRead}
          onDelete={onDelete}
          onClick={onNotificationClick}
        />
      ))}
    </div>
  )
}
